export default __webpack_public_path__ + "static/media/news-1.9c4a71e0.jpg";